var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('section',{attrs:{"id":"member"}},[_c('div',{staticClass:"inner w1400"},[_c('MemberSideNav'),_c('div',{staticClass:"show_area"},[_c('router-view')],1)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }